import { ApiBase } from './api-base';
import { ApiCommunications } from '../../webmodule-common/interop/webmodule-interop';
import { BlobApi } from './blob-api';
import {
  InputCopyFilesByVirtualPath,
  InputDeleteFilesByVirtualPath,
  InputUpdateFileByVirtualPath,
  ResultCopyFilesByVirtualPath,
  ResultDeleteFilesByVirtualPath,
  ResultUpdateFileByVirtualPath
} from '../api/supplier-api-interface-blob';
import { NullPromise } from '../../webmodule-common/interop/webmodule-interop';

export class BlobApiImpl extends ApiBase implements BlobApi {
  constructor(api: ApiCommunications) {
    super(api, 'api/file/');
  }

  async copyFilesByVirtualPath(input: InputCopyFilesByVirtualPath): NullPromise<ResultCopyFilesByVirtualPath> {
    return await this.post<ResultCopyFilesByVirtualPath>('CopyFilesByVirtualPath', input);
  }

  async deleteFilesByVirtualPath(input: InputDeleteFilesByVirtualPath): NullPromise<ResultDeleteFilesByVirtualPath> {
    return await this.post<ResultDeleteFilesByVirtualPath>('DeleteFilesByVirtualPath', input);
  }

  async updateFileByVirtualPath(input: InputUpdateFileByVirtualPath): NullPromise<ResultUpdateFileByVirtualPath> {
    return await this.post<ResultUpdateFileByVirtualPath>('UpdateFileByVirtualPath', input);
  }

  fullUrl(path: string): string {
    return this.api.fullUrl(`${this.apiPath}${path}`);
  }
}
